import { MuiThemeProvider } from "@material-ui/core/styles";
import * as React from "react";
import { Provider } from "react-redux";

import { DefaultTheme } from "./assets/MuiTheme";
import ErrorCatcher from "./components/ErrorCatcher/ErrorCatcher";
import MainNavigator from "./scenes/Navigation/MainNavigator";
import store from "./state/store/store";

const App = () => (
  <ErrorCatcher>
    <Provider store={store}>
      <MuiThemeProvider theme={DefaultTheme}>
        <MainNavigator />
      </MuiThemeProvider>
    </Provider>
  </ErrorCatcher>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx